import React from 'react';
import LabelRowWithActions, {
  Props as ILabelRowWithActionsProps,
} from 'components/searchAndFilter/components/labelRowWithActions';

interface Props {
  columns: ILabelRowWithActionsProps[];
  onCheckboxChange?: any;
}

const ColumnListWithCheckbox = (props: Props) => {
  const { columns, onCheckboxChange } = props;
  return (
    <div
      id="columnlistwithcheckbox-main-container"
      className="top-level pl-[4px] pr-[15px] max-h-full overflow-scroll"
    >
      <div
        id="columnlistwithcheckbox-columns-wrapper"
        className="pt-[4px] pb-[4px] pl-[8px]"
      >
        {
          <>
            {columns.map((columnProps, index) => (
              <LabelRowWithActions
                {...columnProps}
                key={`lrw${index}`}
                {...(onCheckboxChange ? { onCheckboxChange } : {})}
                labelClass="text-[16px]"
              />
            ))}
          </>
        }
      </div>
    </div>
  );
};

export default ColumnListWithCheckbox;
